import React from 'react';
import {
    Col, FormGroup, Input, Label,
    Row
} from 'reactstrap';

import {LangController} from "../../../../components/tabs/langController";


const ActivityLangs = props => {
    const setDataDefault = (activeLangs, setLangChilds) => {
        const items = activeLangs.map( lang => ({
            id: '',
            lang: { id:lang?.id, name:lang?.name, showOrder: lang?.showOrder },
            name: '',
            description: '',
            included: '',
            warning: '',
            genreDetail: '',
            artist: '',
            sellingUrl: ''
        }) )
        setLangChilds(items);
    }
    const formEvents = (child, index, disableInputs, onInputChange) => <>
        <Row>
            <Col md="12">
                <FormGroup>
                    <Label >Nombre</Label>
                    <Input type="text"
                           name="name"
                           placeholder="Ingrese el nombre"
                           value= { child.name }
                           onChange={e => onInputChange(e, child.lang)}
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
           <Col md="12">
                <FormGroup>
                    <Label >URL de venta</Label>
                    <Input type="text"
                           name="sellingUrl"
                           placeholder="URL de venta"
                           value= { child.sellingUrl }
                           onChange={e => onInputChange(e, child.lang)}
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md="12">
                <FormGroup>
                    <Label >Descripción</Label>
                    <Input type="textarea"
                           rows="8"
                           name="description"
                           placeholder="Ingrese descripción"
                           value={child.description}
                           onChange={e => onInputChange(e, child.lang)}
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            {/*<Col md="6">
                <FormGroup>
                    <Label >Detalles del genero</Label>
                    <Input type="name" name="genreDetail"
                           placeholder="Ingrese el detalle del genero"
                           value= { child.genreDetail }
                           onChange={e => onInputChange(e, child.lang)}
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>
            <Col md="6">
                <FormGroup>
                    <Label >Artista</Label>
                    <Input type="name"
                           name="artist"
                           placeholder="Ingrese un artista"
                           value={child.artist}
                           onChange={e => onInputChange(e, child.lang)}
                           disabled={disableInputs}
                    />
                </FormGroup>
            </Col>*/}
        </Row>
    </>


    return <LangController
        langs={props.langs}
        setLangs={props.setLangs}
        getFormulary={formEvents}
        setDataDefault={setDataDefault}
        translatableLangs={props.translatableLangs}
    />
}

export default ActivityLangs
